import { combineReducers } from 'redux'

import * as project from './project'
import * as projects from './projects'
import * as creative from './creative'
import * as ui from './ui'
import * as user from './user'

// Registers the side effects that used to be returned as redux-loop commands.
import './project/listeners'
import './projects/listeners'
import './creative/listeners'
import './user/listeners'

export { listenerMiddleware } from './listener'

export default combineReducers({
  projects: projects.reducer,
  project: project.reducer,
  creative: creative.reducer,
  ui: ui.reducer,
  user: user.reducer,
})

// TODO@bojan Investigate difference between interface and type alias and
// possibly disable another tslint draconian rule.
export interface State {
  projects: projects.State
  project: project.State
  creative: creative.State
  ui: ui.State
  user: user.State
}
